// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Upload_wrapper__22iAY","label":"Upload_label__382zI","disabled":"Upload_disabled__3Gam0"};